import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import useAuth from "../../hooks/useAuth";
import { observer } from "mobx-react-lite";
import ROUTES from "../../utils/routes";

export default observer(function RequireAuth({ children }) {
  RequireAuth.propTypes = {
    children: PropTypes.node,
  };
  const { token } = useAuth();
  const location = useLocation();

  if (!token) {
    return (
      // replace: закрытый адрес не должен оставаться в истории. Иначе «Назад» на
      // регистрации возвращал на него, RequireAuth снова кидал на регистрацию — петля
      // (баг 28.09: гость из теста → анкета → регистрация → «Назад» не работал)
      <Navigate
        replace
        to={ROUTES.REGISTER_PAGE}
        state={{
          from:
            location.pathname === ROUTES.PAYMENT_PAGE
              ? ROUTES.LANDING_PAGE
              : location.pathname,
        }}
      />
    );
  }

  return children;
});
